import {
  ChangeDetectionStrategy,
  Component,
  OnDestroy,
  Renderer2,
  ViewEncapsulation,
  computed,
  effect,
  inject,
  input,
  model,
  signal,
} from '@angular/core';
import { RouterLink, RouterLinkActive } from '@angular/router';

import { BadgeModule } from 'primeng/badge';
import { ButtonModule } from 'primeng/button';

import { TranslocoModule } from '@jsverse/transloco';

import { ButtonActionDirective, ButtonSidebarDirective } from '../directives/index';
import { SidebarConfig } from './sidebar.interface';

@Component({
  selector: 'nbx-sidebar',
  standalone: true,
  imports: [
    BadgeModule,
    ButtonModule,
    RouterLink,
    RouterLinkActive,
    TranslocoModule,
    ButtonSidebarDirective,
    ButtonActionDirective,
  ],
  templateUrl: './sidebar.component.html',
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SidebarComponent implements OnDestroy {
  private readonly _renderer = inject(Renderer2);
  private _resizeListener?: () => void;

  public readonly config = input.required<SidebarConfig>();
  public readonly styleClass = input<string>('');

  public collapsed = model<boolean>(false);

  public readonly showCloseButton = computed(() => {
    const mobile = this.isTablet();
    const isCollapsed = this.collapsed();
    return mobile && !isCollapsed;
  });

  public readonly isTablet = signal(typeof window !== 'undefined' && window.innerWidth < 745);

  constructor() {
    if (typeof window !== 'undefined') {
      this._resizeListener = this._renderer.listen('window', 'resize', () => {
        this.isTablet.set(window.innerWidth < 745);
        this.collapsed.update(() => true);
      });
    }

    effect(() => {
      const isTablet = this.isTablet();

      if (isTablet) {
        this.collapsed.set(true);
      }
    });
  }

  ngOnDestroy(): void {
    if (this._resizeListener) {
      this._resizeListener();
    }
  }
}
